import { render } from "./LaboratoryQueueModal.vue?vue&type=template&id=b132576a"
import script from "./LaboratoryQueueModal.vue?vue&type=script&lang=js"
export * from "./LaboratoryQueueModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__